import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import Link from 'flarum/common/components/Link';

export default class CustomFooter extends Component {
  view() {
    return (
      <div class="container">
        <p>© Busch-Jaeger Elektro GmbH 2025</p>
        <ul>{listItems(this.items().toArray())}</ul>
      </div>
    );
  }

  items() {
    const items = new ItemList();
    items.add(
      'impressum',
      <li>
        <Link target="_blank" href="https://www.busch-jaeger.de/impressum">
          Impressum
        </Link>
      </li>,
      0
    );
    items.add(
      'datenschutzerklaerung',
      <li>
        <Link href="/p/datenschutzerklaerung">Datenschutzerklärung</Link>
      </li>,
      0
    );
    items.add(
      'nutzungsbedingungen',
      <li>
        <Link href="/p/nutzungsbedingungen">Nutzungsbedingungen</Link>
      </li>,
      0
    );
    items.add(
      'cookie',
      <li
        onclick={() => {
          UC_UI.showSecondLayer();
          return false;
        }}
      >
        Cookie-Einstellungen
      </li>,
      0
    );

    if (app.session?.user && app.session?.user.data.attributes.isAdmin) {
      items.add(
        'session',
        <li>
          <Link target="_blank" href="/admin">
            Dashboard
          </Link>
        </li>,
        10
      );
    }

    return items;
  }
}
